import React from "react";

Pill.Error = ({ children, className }) => (
    <Pill type="error" className={className}>
        {children}
    </Pill>
);

Pill.Success = ({ children, className }) => (
    <Pill type="success" className={className}>
        {children}
    </Pill>
);

function Pill ({ children, type, className }) {
    let colourClassName = '';

    switch (type) {
        case "success":
            colourClassName = "bg-green-100 text-green-800";
            break;
        case "error":
            colourClassName = "bg-red-100 text-red-800";
            break;
    }

    return (
        <span className={`px-2 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${className} ${colourClassName}`}>
            {children}
        </span>
    );
};

export default Pill;
